import { supabase } from '@/lib/supabase';
import type { OfferKind, OfferLineItem } from '@/lib/offers';

export type OfferTemplate = {
  id: string;
  user_id: string;
  name: string;
  title: string;
  description: string | null;
  cost: number | null;
  delivery_days: number | null;
  type: 'one_off' | 'ongoing' | 'fixed_term';
  start_date: string | null;
  end_date: string | null;
  include_professional_terms: boolean;
  offer_kind: OfferKind;
  line_items: OfferLineItem[] | null;
  created_at: string;
};

export const MAX_OFFER_TEMPLATES = 3;

export async function listOfferTemplates(): Promise<OfferTemplate[]> {
  const { data, error } = await supabase
    .from('offer_templates')
    .select('*')
    .order('created_at', { ascending: true });
  if (error) throw new Error(error.message);
  return (data ?? []) as unknown as OfferTemplate[];
}

export type NewOfferTemplateInput = Omit<OfferTemplate, 'id' | 'user_id' | 'created_at'>;

export async function saveOfferTemplate(input: NewOfferTemplateInput): Promise<OfferTemplate> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Δεν είσαι συνδεδεμένος.');
  const { data, error } = await supabase
    .from('offer_templates')
    .insert({
      user_id: user.id,
      name: input.name,
      title: input.title,
      description: input.description,
      cost: input.cost,
      delivery_days: input.delivery_days,
      type: input.type,
      start_date: input.start_date,
      end_date: input.end_date,
      include_professional_terms: input.include_professional_terms,
      offer_kind: input.offer_kind,
      line_items: input.line_items,
    } as never)
    .select()
    .single();
  if (error) throw new Error(error.message);
  return data as unknown as OfferTemplate;
}

export async function deleteOfferTemplate(id: string): Promise<void> {
  const { error } = await supabase.from('offer_templates').delete().eq('id', id);
  if (error) throw new Error(error.message);
}

export async function renameOfferTemplate(id: string, name: string): Promise<void> {
  const { error } = await supabase
    .from('offer_templates')
    .update({ name } as never)
    .eq('id', id);
  if (error) throw new Error(error.message);
}
